import { createTheme } from "@mui/material";
import type { Theme } from "@mui/material";
import InputStyles from "@components/Input/Input.styles";

const applyThemePalette = (theme: Theme): Theme =>
  createTheme({
    ...theme,
    palette: {
      mode: "light",
      primary: {
        main: "#0A46B7",
        // light: will be calculated from palette.primary.main,
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated from palette.primary.main,
      },
      secondary: {
        main: "#333333",
      },
      info: {
        main: "#4F46E5",
      },
      success: {
        main: "#00B49D",
      },
      warning: {
        main: "#DC6726",
      },
      error: {
        main: "#E1172F",
      },
      background: {
        default: "#FFFFFF",
        navigation: "#F7F8FA",
        menu: "#EBF0F6",
      },
      text: {
        primary: "#333333",
        secondary: "#646A77",
        brand: "#0A46B7",
        placeholder: "#A6AAB3",
        white: "#FFFFFF",
      },
      action: {
        hover: "#EBF0F6",
        selected: "#EBF0F6",
      },
      strokeColor: {
        primary: "#BBC1C5",
        secondary: "#E6EDF2",
      },
      custom: {
        main: "#DE1395",
        secondary: "#1EB3DB",
      },
    },
  });

const applyThemeTypography = (theme: Theme): Theme =>
  createTheme({
    ...theme,
    typography: {
      fontFamily: '"Inter", sans-serif',
      allVariants: {
        // fallback Arabic font
        fontFamily: `"Inter", "Noto Kufi Arabic", sans-serif`,
      },
      body1: {
        fontWeight: 400,
        fontSize: 14,
      },
      body2: {
        fontWeight: 700,
        fontSize: 16,
      },
      fontSize: 14,
      fontWeightBold: 700,
      fontWeightLight: 600,
      fontWeightMedium: 500,
      fontWeightRegular: 400,
    },
  });

const customTheme = (): Theme => {
  let theme = createTheme();
  theme = applyThemePalette(theme);
  theme = applyThemeTypography(theme);
  theme = createTheme({
    ...theme,
    components: {
      ...InputStyles,
    },
  });
  return theme;
};
export default customTheme;
